var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_737_560)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_737_560",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V30H30V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_737_560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V30H30V0Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8757 23.75C11.1201 23.75 8.76615 23.75 7.02212 23.75C6.09288 23.75 5.48964 22.7721 5.9052 21.941L6.97283 19.8057C7.31997 19.1115 7.50069 18.3468 7.50069 17.5705C7.50069 16.6084 7.50069 15.1792 7.50069 13.75C7.50069 11.25 8.75069 6.25 15.0007 6.25C21.2507 6.25 22.5007 11.25 22.5007 13.75C22.5007 15.1792 22.5007 16.6084 22.5007 17.5705C22.5007 18.3468 22.6814 19.1115 23.0286 19.8057L24.0962 21.941C24.5117 22.7721 23.9073 23.75 22.9782 23.75H18.1257M11.8757 23.75C11.8757 26.25 13.1257 27.5 15.0007 27.5C16.8757 27.5 18.1257 26.25 18.1257 23.75M11.8757 23.75C13.8283 23.75 18.1257 23.75 18.1257 23.75",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6.25V3.75",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_737_560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.a89e303134fd3f9c9f63ff27ab0c79f4.svg";
export { ForwardRef as ReactComponent };